'use strict';
// Published texture LP; consent-aware measurement is loaded separately.
const menu=document.querySelector('#menu'),toggle=document.querySelector('.menu-toggle');
let returnFocus=null;
let menuDestination=null;
function openDialog(d){returnFocus=document.activeElement;d.showModal();if(d===menu)toggle.setAttribute('aria-expanded','true');}
function closeDialog(d){d.close();}
for(const d of document.querySelectorAll('dialog')){
 d.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>closeDialog(d)));
 d.addEventListener('close',()=>{
  if(d===menu)toggle.setAttribute('aria-expanded','false');
  const destination=d===menu?menuDestination:null;
  menuDestination=null;
  if(destination){
   requestAnimationFrame(()=>{
    if(!destination.hasAttribute('tabindex')){
     destination.setAttribute('tabindex','-1');
     destination.addEventListener('blur',()=>destination.removeAttribute('tabindex'),{once:true});
    }
    destination.focus({preventScroll:true});
    destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
   });
  }else returnFocus?.focus({preventScroll:true});
 });
 d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeDialog(d);}});
}
toggle.addEventListener('click',()=>openDialog(menu));
menu.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{
 const id=a.getAttribute('href').slice(1),destination=document.getElementById(id);
 if(!destination)return;
 e.preventDefault();
 menuDestination=destination;
 if(location.hash!==a.hash)history.pushState(null,'',a.hash);
 closeDialog(menu);
}));
const viewer=document.querySelector('#viewer'),large=document.querySelector('#large-photo'),stage=document.querySelector('.photo-stage'),zoom=document.querySelector('#zoom');
function setZoom(next){stage.classList.toggle('zoomed',next);zoom.setAttribute('aria-pressed',String(next));zoom.textContent=next?'全体を見る':'さらに拡大';if(!next){stage.scrollTop=0;stage.scrollLeft=0;}}
document.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>{large.src=window.textureAssets[b.dataset.photo];large.alt=b.querySelector('img').alt;document.querySelector('#photo-title').textContent=large.alt;setZoom(false);openDialog(viewer);}));
zoom.addEventListener('click',()=>setZoom(!stage.classList.contains('zoomed')));
large.addEventListener('click',()=>setZoom(!stage.classList.contains('zoomed')));
document.querySelector('[data-report]').addEventListener('click',()=>openDialog(document.querySelector('#report')));
const gif=document.querySelector('#color-animation'),gifToggle=document.querySelector('#gif-toggle'),reduced=matchMedia('(prefers-reduced-motion: reduce)');let playing=false;
function playGif(next){playing=next;gif.src=next?gif.dataset.gif:gif.dataset.still;gifToggle.setAttribute('aria-pressed',String(next));gifToggle.textContent=next?'動きを止める':'動きを見る';}
gifToggle.hidden=false;
let gifVisible=false,gifPausedByUser=false;
gifToggle.addEventListener('click',()=>{gifPausedByUser=playing;playGif(!playing);});
reduced.addEventListener('change',e=>playGif(gifVisible&&!e.matches&&!gifPausedByUser));
if('IntersectionObserver'in window)new IntersectionObserver(entries=>{
 gifVisible=entries[0].isIntersecting;
 playGif(gifVisible&&!reduced.matches&&!gifPausedByUser);
},{rootMargin:'150px'}).observe(gif);
else playGif(!reduced.matches);
for(const video of document.querySelectorAll('video')){
 video.controls=false;video.defaultMuted=true;video.muted=true;let visible=false;
 const sync=()=>{if(visible&&!document.hidden){const source=video.querySelector('source[data-src]');if(source){source.src=source.dataset.src;source.removeAttribute('data-src');video.load();}video.play()?.catch(()=>{});}else video.pause();};
 if('IntersectionObserver'in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.1}).observe(video);else{visible=true;sync();}
 document.addEventListener('visibilitychange',sync);video.addEventListener('loadedmetadata',sync);
}
// LINE registration remains visible at every viewport size and scroll position.

(()=>{const q=new URLSearchParams(location.search);const paid=['meta','facebook','instagram'].includes((q.get('utm_source')||'').toLowerCase())&&q.get('utm_medium')==='paid_social'&&q.get('utm_campaign')==='tokutouseki_texture_20260924';document.querySelectorAll('a[data-line]').forEach(a=>{a.href=paid?'https://lin.ee/UASR94X':'https://lin.ee/V2xo9hj';a.dataset.lineRoute=paid?'7193833':'7193842';a.dataset.trafficSegment=paid?'texture_meta':'texture_other';});})();
